import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: (value) =>
    api
      .send({
        query: gql`
          query distritoByCanton($idCanton: String!) {
            TYPES {
              Distrito {
                readByCanton(idCanton: $idCanton) {
                  id
                  value
                  annotation
                  idCanton
                  codigo
                }
              }
            }
          }
        `,
        variables: {
          idCanton: value,
        },
      })
      .then((result) => result.data.data.TYPES.Distrito.readByCanton),
};
